// CardWrap.js
import {
  defineComponent,
  computed,
  inject,
  ref,
} from "/Scripts/vue.esm-browser.js";
import ProductCard, {
  buildCardViewModel,
} from "/Component/Shop/product/ProductCard.js";
const html = String.raw;

const ensureCardViewModel = (item) => {
  if (!item) return item;
  if (
    item.cardViewModel &&
    item.__cardViewModelGroups === item.groups &&
    item.__cardViewModelPicture === item.picture
  ) {
    return item;
  }

  Object.defineProperties(item, {
    cardViewModel: {
      configurable: true,
      writable: true,
      value: buildCardViewModel(item),
    },
    __cardViewModelGroups: {
      configurable: true,
      writable: true,
      value: item.groups,
    },
    __cardViewModelPicture: {
      configurable: true,
      writable: true,
      value: item.picture,
    },
  });

  return item;
};

const getCardKey = (item) => item?.groups?.[0]?.groupCode || item?.mainGroupCode;

export default defineComponent({
  name: "CardWrap",
  components: {
    ProductCard,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    groupShowType: {
      type: String,
    },
    isAllProduct: {
      type: Boolean,
      default: false,
    },
    isSearch: {
      type: Boolean,
      default: false,
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
    isFilterOpen: {
      type: Boolean,
    },
    dataLoaded: {
      type: Boolean,
    },
  },
  emits: [],
  setup(props, { emit }) {
    const mobileFilterPopup = inject("mobileFilterPopup", ref(false));
    const items = computed(() => props.items);
    const showAllClicked = ref(false);
    let groupShowType = inject("groupShowType");

    //如果有傳進來就用傳進來的 例如其他出發日期一定是uni模式
    if (props.groupShowType) {
      groupShowType = props.groupShowType;
    }
    const loopItems = computed(() => {
      if (
        groupShowType.value === "uni" &&
        (!props.isAllProduct || !props.isSearch)
      ) {
        const visibleItems = showAllClicked.value
          ? items.value
          : items.value.slice(0, 10);
        return visibleItems.map(ensureCardViewModel);
      } else {
        return items.value
          .filter((item) => item.groups.length > 0)
          .map(ensureCardViewModel);
      }
    });
    const handleShowAllClick = () => {
      showAllClicked.value = true;
    };

    return {
      items,
      loopItems,
      groupShowType,
      mobileFilterPopup,
      showAllClicked,
      handleShowAllClick,
      getCardKey,
    };
  },
  template: html`
    <div
      class="card_wrap"
      :class="{
                'horizontal_full': (groupShowType === 'horizontal' || groupShowType === 'region') && !isFilterOpen,
                'horizontal': (groupShowType === 'horizontal' || groupShowType === 'region') && isFilterOpen,
                'uni': groupShowType === 'uni',
                'vertical': groupShowType === 'vertical'
            }"
    >
      <template v-if="dataLoaded">
        <div class="noProduct_text" v-if="isEmpty">
          沒有相符的產品，請重新搜尋
        </div>
        <div class="noProduct_text" v-else>
          沒有相符的產品，請<button
            class="filter_dialog_btn"
            @click="mobileFilterPopup=true"
          >
            重新篩選
          </button>
        </div>
      </template>
      <product-card
        v-for="item in loopItems"
        :key="getCardKey(item)"
        :item="item"
        :isAllProduct="isAllProduct"
        :isSearch="isSearch"
        :groupShowType="groupShowType"
      ></product-card>
      <div
        class="card_moreproduct_toggle"
        v-if="items.length > 10 && !isAllProduct && !isSearch && !showAllClicked"
      >
        <div
          class="card_moreproduct_btn all_product_btn"
          @click="handleShowAllClick"
        >
          顯示全部
          <div class="card_moreproduct_count">{{items.length}}</div>
        </div>
      </div>
    </div>
  `,
  methods: {},
});
